import { toTypedSchema } from '@vee-validate/zod'
import { object, boolean } from 'zod'
import { passwordSchema, emailValidationSchema } from '@/schemas/auth/index'

export const loginSchema = toTypedSchema(
  object({
    email: emailValidationSchema,
    password: passwordSchema,
    remember: boolean(),
  }),
)
